import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import bg from './../../assets/video-page-bg.svg'

const styles = () => ({
  root: {
    position: 'relative',
    minHeight: '100vh',
    backgroundImage: `url(${bg})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'right top',
  },
  flightWrap: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
  },
  flightSvg: {
    display: 'block',
    width: '100%',
    height: 187,
  },
})

let BannerVideoList = ({ classes }) => (
  <div className={`${classes.root} fixedBackground`}>
    <div className={classes.flightWrap} aria-hidden="true">
      <svg
        className={classes.flightSvg}
        viewBox="0 0 1440 187"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <path d="M-88 185.783H114.805C121.657 185.783 128.231 183.079 133.099 178.258L304.401 8.63335C309.269 3.8126 315.843 1.1083 322.695 1.1083H581.5H683.662H869H1475.5" stroke="#C0D2E5" strokeDasharray="4 4"/>
        <path d="M232.52 80.5501L202.764 109.49C201.914 110.317 200.681 110.617 199.544 110.274L189.441 107.224L193.784 104.799L200.93 105.512L210.618 95.8225L188.454 98.2983L191.26 95.5691L218.654 88.0071L220.75 85.969C223.889 82.9155 227.779 80.7437 232.027 79.6714C232.544 79.5411 232.901 80.179 232.52 80.5501Z" fill="#4B9CF0"/>
      </svg>
    </div>
  </div>
)

export default withStyles(styles)(BannerVideoList)
